import { atom } from "jotai";
import { atomWithDefault } from "jotai/utils";

export interface Toggles {
  dataPoc: boolean;
  viewOnlyDowntime: boolean;
  aiComposerDevTools: boolean;
  showWhatsNewAlert: {
    isOn: boolean;
    config: {
      url: "";
    };
  };
  aiComposerDataPills: boolean;
  fieldMappingComposer: boolean;
  aiCobuildCopilot: boolean;
}

/* Only to be used by the CanvasHydrator, not in the UI */
export const togglesAtom = atom<Toggles>({
  dataPoc: false,
  viewOnlyDowntime: false,
  aiComposerDevTools: false,
  aiComposerDataPills: false,
  fieldMappingComposer: false,
  aiCobuildCopilot: false,
  showWhatsNewAlert: {
    isOn: false,
    config: {
      url: "",
    },
  },
});

togglesAtom.debugLabel = "togglesAtom";

/* Use this atom in the UI since we need to be able to reset it to the state set by CanvasHydrator in DevTools */
export const togglesAtomResettable = atomWithDefault((get) => get(togglesAtom));

togglesAtomResettable.debugLabel = "togglesAtomResettable";
